module.exports = __webpack_public_path__ + "img/stars_three.1703ab26.svg";